<template>
	<b-form @submit.stop.prevent="$emit('save')">
		<b-modal :id="modalId" title="Unsaved changes" hide-footer no-close-on-backdrop no-close-on-esc>
			<p>You have unsaved changes. What would you like to do?</p>
			<div class="d-flex justify-content-end" style="gap: 0.5rem">
				<b-button variant="success" @click="onLeaveSave">Save</b-button>
				<b-button variant="danger" @click="onLeaveDiscard">Discard</b-button>
				<b-button variant="secondary" @click="onLeaveCancel">Cancel</b-button>
			</div>
		</b-modal>
		<b-form-row>
			<b-col cols="12" lg="6">
				<slot />
			</b-col>
			<b-col cols="12" lg="6" class="preview-col">
				<div class="preview-inner">
					<preview ref="preview" class="mb-3" :slug="slug" :name="name" :default-width="defaultWidth" :show-audio="showAudio">
						<template v-if="$scopedSlots.preview" v-slot="scope">
							<slot name="preview" v-bind="scope" />
						</template>
						<template v-if="$slots['preview-options'] || $scopedSlots['preview-options']" #options>
							<slot name="preview-options" />
						</template>
					</preview>
					<div class="sticky-save-card mb-3">
						<b-card class="text-center">
							<b-alert variant="danger" :show="!!error">{{ error }}</b-alert>
							<b-overlay :show="saving > 0" variant="dark" class="d-inline-block">
								<b-dropdown v-if="settings && savedSettingsJson" split text="Save settings" split-variant="primary" variant="primary" :disabled="!hasUnsavedChanges" no-caret right @click="$emit('save')">
									<b-dropdown-item @click.stop="copyUrlWithChanges">Copy URL with current changes</b-dropdown-item>
								</b-dropdown>
								<b-button v-else variant="primary" type="submit" :disabled="!hasUnsavedChanges">Save settings</b-button>
							</b-overlay>
							<slot name="save-extra" />
						</b-card>
					</div>
				</div>
			</b-col>
		</b-form-row>
	</b-form>
</template>

<script>
import Preview from '@/components/Widget/Preview.vue';

export default {
	components: { Preview },
	props: {
		slug: { type: String, required: true },
		name: { type: String, required: true },
		defaultWidth: { type: Number, default: 0 },
		showAudio: { type: Boolean, default: false },
		error: { default: null },
		saving: { type: Number, default: 0 },
		hasUnsavedChanges: { type: Boolean, default: false },
		settings: { type: Object, default: null },
		savedSettingsJson: { type: String, default: null },
	},
	computed: {
		modalId() { return `leave-modal-${this._uid}`; },
	},
	methods: {
		copyUrlWithChanges() {
			const saved = JSON.parse(this.savedSettingsJson);
			const changed = {};
			for(const [key, value] of Object.entries(this.settings)) {
				if(JSON.stringify(value) !== JSON.stringify(saved[key])) changed[key] = value;
			}
			const url = new URL(this.$refs.preview.widgetUrl);
			for(const [key, value] of Object.entries(changed)) {
				url.searchParams.set(key, value);
			}
			this.$util.copyToClipboard(url.toString());
			this.$bvToast.toast('Widget URL with current changes copied to clipboard', { title: 'Copied', variant: 'success', solid: true });
		},
		showLeaveModal(next, save) {
			this._leaveNext = next;
			this._leaveSave = save;
			this.$bvModal.show(this.modalId);
		},
		async onLeaveSave() {
			this.$bvModal.hide(this.modalId);
			try {
				await this._leaveSave();
				this._leaveNext();
			} catch(e) {
				this._leaveNext(false);
			}
		},
		onLeaveDiscard() {
			this.$bvModal.hide(this.modalId);
			this._leaveNext();
		},
		onLeaveCancel() {
			this.$bvModal.hide(this.modalId);
			this._leaveNext(false);
		},
	},
	mounted() {
		const el = this.$refs.preview?.$el;
		if (!el) return;
		const update = () => this.$el.style.setProperty('--preview-h', el.offsetHeight + 'px');
		this._previewObs = new ResizeObserver(update);
		this._previewObs.observe(el);
		update();
	},
	beforeDestroy() {
		this._previewObs?.disconnect();
	},
};
</script>

<style scoped>
@media (min-width: 992px) {
	.preview-inner {
		position: sticky;
		top: 1em;
		display: flex;
		flex-direction: column;
	}
	.preview-col {
	}
	.sticky-save-card {
		/*position: sticky;*/
		/* top guard: preview's sticky offset (1rem) + preview height + 1rem gap */
		top: calc(var(--preview-h, 0px) + 2rem);
		bottom: 1rem;
		margin-top: auto;
	}
}
</style>
